import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Grid, Icon, IconButton, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import { ApiGenerateInvoice, ApiGenerateMasterInvoice, ApiGenerateShopperInvoice, ApiGenerateShopperInvoicePDF, ApiGenerateShopperWiseInvoice, ApiGetGeneratedInvoiceList, ApiGetInvoiceReportList, ApiGetInvoiceStatus, ApiGetShopperList, ApiUpdateBulkStatus, ApiGetAirTaskerTasks, ApiGetExcelDataForAirTaskerJobs, ApiExportCheckedInvoice, ApiGenerateABA } from '../../../apiService/Core/Apicall.tsx'
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { toast } from 'react-toastify';
import { Cancel, CancelOutlined, Clear, LocalAtm, PictureAsPdf, RampRightOutlined, SettingsBackupRestore } from '@mui/icons-material';
import { Check, Copy } from 'lucide-react';
import details from '../../../assets/images/details.png'
import { Link, useNavigate } from 'react-router-dom';
import dayjs, { Dayjs } from "dayjs";


function PayInvoice() {
    const [selectedShopper, setSelectedShopper] = useState<any>()
    const [searchShopper, setsearchShopper] = useState<any>([])
    const [datalength, setdatalength] = useState<any>(null);
    const [selectedRow, setSelectedRow] = useState<any>([]);
    const [reportlist, setreportlist] = useState<any>([]);
    const [shopperlist, setshopperlist] = useState<any>([]);
    const [page, setPage] = useState(0);
    const [marked, setMarked] = useState<string>('false');
    const [statusList, setStatusList] = useState<any>([]);
    const [status, setStatus] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const navigate = useNavigate()
    const [selectedDate, setSelectedDate] = useState<Date>(new Date());
    const [airtaskerDialogOpen, setAirtaskerDialogOpen] = useState(false);
    const [airTaskerStatsData, setAirTaskerStatsData] = useState<any>([]);



    // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getgeneratedinvoice = async () => {
        try {
            const data = `?month=${selectedDate?.getMonth() + 1}&year=${selectedDate?.getFullYear()}${selectedShopper ? `&userId=${selectedShopper.userId}` : ''}&isInvoiceChecked=${marked}${status !== 0 ? `&shopperInvoiceStatusId=${status}` : ''}`
            const res = await ApiGetGeneratedInvoiceList(data)
            // console.log("Report Data", res.data)
            setreportlist(res.data)
            setdatalength(res.totalCount)
        } catch (error) {
            console.log(error)
        }
    }

    const getShopperList = async () => {
        try {
            const data = `?offset=0&limit=1000${searchShopper?.length > 0 ? `&search=${searchShopper}` : ''}`
            const res = await ApiGetShopperList(data)
            setshopperlist(res.data)
            const defaultselected = (res.data?.filter(item => item.firstName !== ''))
            // setSelectedShopper(defaultselected[0])

        } catch (error) {
            alert(error)
        }
    }
    const getInvoiceStatus = async () => {
        try {
            const data = `?offset=0&limit=1000`
            const res = await ApiGetInvoiceStatus()
            setStatusList(res.data)
        } catch (error) {
            alert(error)
        }
    }

    const markSelectedStatus = async (type: string) => {
        if (selectedRow.length > 0) {
            try {
                const data = {
                    shopperInvoiceIds: selectedRow,
                    updateType: type,       // "bulkChecked", "bulkConfirmed"
                    modifiedBy: localStorage.getItem('userRole')
                }
                const res = await ApiUpdateBulkStatus(data)
                toast.success(res.message)
                getgeneratedinvoice()
                setSelectedRow([])
            } catch (error) {
                alert(error)
            }
        }
        else {
            toast.error("Please Select Invoice")
        }

    }

    const handleSinglePay = async (item) => {
        try {
            const data = {
                shopperInvoiceIds: [item?.shopperInvoiceId],
                updateType: 'bulkPaid',
                modifiedBy: localStorage.getItem('userRole')
            }
            const res = await ApiUpdateBulkStatus(data)
            toast.success(res.message)
            getgeneratedinvoice()
            setSelectedRow([])
        } catch (error) {
            alert(error)
        }
    }



    useEffect(() => {
        getShopperList()
        getInvoiceStatus()
    }, [])

    useEffect(() => {
        getShopperList()
    }, [searchShopper])


    useEffect(() => {
        getgeneratedinvoice()
    }, [selectedDate, selectedShopper, status, marked])


    const handleSelectRow = (index: number) => {
        setSelectedRow((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };



    const ExportASABA = async () => {
        const data = `?month=${selectedDate?.getMonth() + 1}&year=${selectedDate?.getFullYear()}`
        try {
            const res = await ApiGenerateABA(data);

            const blob = new Blob([res], {
                type: 'application/octet-stream',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Invoices_${selectedDate?.getMonth() + 1}_${selectedDate?.getFullYear()}.aba`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }
    const ShopperWiseInvoice = async () => {
        const data = `?month=${selectedDate?.getMonth() + 1}&year=${selectedDate?.getFullYear()}`
        try {
            const res = await ApiGenerateShopperWiseInvoice(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Shopper_Wise_Invoice.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }
    const ExportCheckdInvoice = async () => {
        const data = `?month=${selectedDate?.getMonth() + 1}&year=${selectedDate?.getFullYear()}`
        try {
            const res = await ApiExportCheckedInvoice(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Checked_Shoppers.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }
    const ShopperInvoice = async () => {
        const data = `?month=${selectedDate?.getMonth() + 1}&year=${selectedDate?.getFullYear()}`
        try {
            const res = await ApiGenerateShopperInvoice(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Shopper_Invoice.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }
    const ShopperInvoicePDF = async (shopperInvoiceId, userId) => {
        const data = `?shopperInvoiceId=${shopperInvoiceId}&userId=${userId}`
        try {
            const res = await ApiGenerateShopperInvoicePDF(data);

            const blob = new Blob([res], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            link.download = 'Shopper_Invoice_PDF.pdf';
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url)

        } catch (error) {
            alert(error)
        }
    }

    const GenerateMastreInvoice = async () => {
        const data = `?month=${selectedDate?.getMonth() + 1}&year=${selectedDate?.getFullYear()}`
        try {
            const res = await ApiGenerateMasterInvoice(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Master_Invoice.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }

    const handleAirTaskerStats = async () => {
        try {
            const res = await ApiGetAirTaskerTasks();
            setAirTaskerStatsData(res?.data)
        } catch (error) {
            alert(error)
        }
    }
    const handleDownloadExcel = async () => {
        try {
            const res = await ApiGetExcelDataForAirTaskerJobs();
            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `importExportAllAllocation.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }

    const handleCopyEmail = (email) => {
        if (email) {
            // console.log("Email", email)
            navigator?.clipboard?.writeText(email)
                .then(() => {
                    toast.success('Data Copied');
                })
                .catch((err) => {
                    toast.error('Failed to Copy');
                });
        }
    };
    return (
        <div className='w-100 p-2'>
            <Box className='p-2 py-3 border-10 w-100 bg-light'>
                <Box className='w-100'>
                    <Typography className='text-center fs-42'> Pay Invoice</Typography>
                </Box>
                <Box my={3} gap={{ xs: 2, md: 0 }} className='d-flex w-100 flex-wrap align-items-center justify-content-between'>
                    <Box className='col-md-4 col-12'>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={() => { setAirtaskerDialogOpen(true); handleAirTaskerStats() }}
                        >
                            Airtasker Stats
                        </Button>
                    </Box>
                    <Box className='col-md-4 col-12' sx={{ display: "flex", justifyContent: "center", px: 2 }}>
                        {/* <OliveButton>All Report Status</OliveButton> */}

                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                views={["month", "year"]}
                                label=""
                                value={selectedDate}
                                onChange={(newDate) => newDate && setSelectedDate(newDate)}
                                format="MM/yyyy"
                                sx={{
                                    width: "400px",
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 1,
                                    },
                                }}
                            />
                        </LocalizationProvider>

                        {/* <OliveButton>DOWNLOAD AS XLS</OliveButton> */}
                    </Box>
                    <Box className='d-flex col-md-4 col-12 justify-content-end' gap={1}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={ExportASABA}
                        >
                            Export As ABA
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={ShopperWiseInvoice}
                        >
                            Export Shopper Wise
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={ShopperInvoice}

                        >
                            Export as Excel
                        </Button>
                    </Box>
                </Box>

                <Grid container className='mt-3' gap={1} spacing={2}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl size="medium" fullWidth>
                            <label htmlFor="search_shopper" className='mb-0 pl-1' style={{ fontSize: '16px' }}>Search Shopper</label>
                            <Autocomplete
                                id='serach_shopper'
                                disablePortal
                                options={shopperlist?.filter(item => item.firstName !== '')}
                                value={selectedShopper}
                                onInputChange={(event, newInputValue) => { setsearchShopper(newInputValue) }}
                                getOptionLabel={(option: any) => `${option?.firstName} ${option.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`}
                                isOptionEqualToValue={(option: any, value: any) =>
                                    option.userId === value.userId || option.emailId === value.emailId
                                }
                                filterOptions={(options, { inputValue }) =>
                                    options.filter((option) => {
                                        const fullName = `${option.firstName} ${option.lastName}`.toLowerCase();
                                        const email = option.emailId?.toLowerCase() || '';
                                        const search = inputValue.toLowerCase();
                                        return fullName.includes(search) || email.includes(search);
                                    })
                                }
                                onChange={(event, newValue: any) => {
                                    setSelectedShopper(newValue)
                                }}
                                // defaultValue={shopperlist?.filter(item => item.firstName !== '')[0]}
                                renderInput={(params) => <TextField {...params} />}
                                size="small"
                            />
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl size="small" fullWidth>
                            <label htmlFor="marked" className='mb-0 pl-1' style={{ fontSize: '16px' }}>Marked</label>
                            <Select
                                // className='col-3'
                                id="marked"
                                value={marked}
                                onChange={(e) => setMarked(e.target.value)}
                            >
                                <MenuItem value={'false'} >UnChecked </MenuItem>
                                <MenuItem value={'true'} >Checked </MenuItem>

                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl size="small" fullWidth >
                            <label htmlFor="status" className='mb-0 pl-1' style={{ fontSize: '16px' }}>Status</label>
                            <Select
                                // className='col-3'
                                id="status"
                                value={status}
                                onChange={(e) => e && setStatus(Number(e.target.value))}
                            >
                                <MenuItem value={0} >All</MenuItem>
                                {
                                    statusList.length > 0 && statusList.map((item, index) => (
                                        <MenuItem value={item?.invoiceStatusId} >{item?.invoiceStatusName}</MenuItem>
                                    ))
                                }

                            </Select>
                        </FormControl>
                    </Grid>



                </Grid>
                <Grid container className='mt-4' spacing={2}>
                    <Grid size={{ xs: 6, md: 'grow' }}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={GenerateMastreInvoice}                    >

                            Export Non Invoice Reports
                        </Button>
                    </Grid>
                    <Grid size={{ xs: 6, md: 'grow' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={() => { markSelectedStatus('bulkConfirmed') }}
                        >
                            Mark Selected Confirmed
                        </Button>
                    </Grid>
                    <Grid size={{ xs: 6, md: 'grow' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={() => { markSelectedStatus('bulkChecked') }}

                        >
                            update BULK(Mark Selected Checked)
                        </Button>
                    </Grid>
                    <Grid size={{ xs: 6, md: 'grow' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={() => { ExportCheckdInvoice() }}
                        >
                            Export Checked Shoppers
                        </Button>
                    </Grid>
                    <Grid size={{ xs: 6, md: 'auto' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={() => {
                                markSelectedStatus('bulkPaid')

                            }}                    >
                            Mark Checked as PAID
                        </Button>
                    </Grid>
                </Grid>

                <Box className='w-100 mt-5' overflow={'auto'}>
                    {/* <TableContainer
                        component={Paper}
                        sx={{ mb: 4, border: "1px solid #ccc" }}
                    > */}
                    <Table>
                        <TableHead sx={{ bgcolor: "#7a7d52" }}>
                            <TableRow>
                                <TableCell className='text-center' padding="checkbox" sx={{ color: "white" }}>
                                    <FormControlLabel
                                        className='m-0 p-0'
                                        control={
                                            <Checkbox
                                                indeterminate={
                                                    selectedRow.length > 0 && selectedRow.length < reportlist.length
                                                }
                                                checked={
                                                    reportlist.length > 0 && selectedRow.length === reportlist.length
                                                }
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        // Select all rows
                                                        setSelectedRow(reportlist.map((item) => item?.shopperInvoiceId));
                                                    } else {
                                                        // Deselect all
                                                        setSelectedRow([]);
                                                    }
                                                }}
                                            />
                                        }
                                        label="BULK"
                                    />
                                </TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>DOC</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>SOS</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>Checked</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>Inv#</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>Date/Time</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>Month</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>Shopper</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>Copy</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>Status</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>Total</TableCell>
                                {/* <TableCell sx={{ color: "white", textAlign: 'center' }}>Tnx ID</TableCell> */}
                                {/* <TableCell sx={{ color: "white", textAlign: 'center' }}>Tnx Date</TableCell> */}
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>Reject</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>Pay</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>PDF</TableCell>
                                <TableCell sx={{ color: "white", textAlign: 'center' }}>Details</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                reportlist.length > 0 ? (
                                    reportlist.filter(item => selectedShopper || item?.shopperId === selectedShopper?.userId)
                                        .map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell className='d-flex align-items-start'>
                                                    <Checkbox
                                                        className='px-0 mx-0'
                                                        checked={selectedRow.includes(item?.shopperInvoiceId)}
                                                        onChange={() => { handleSelectRow(item?.shopperInvoiceId) }}
                                                    /></TableCell>
                                                <TableCell>{item?.userId?.driving_licence?.length > 0 ? <Check color='green' />:<Clear sx={{ color: 'red' }} />} </TableCell>
                                                <TableCell>{(item?.userId?.shopperOtherDetails || item?.userId?.shopperOtherDetails?.statementOfsupplier) ? <Check color='green' />:<Clear sx={{ color: 'red' }} />} </TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>{(item?.isInvoiceChecked) ? 'true' : 'false'}</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>{item?.shopperInvoiceId}</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>{dayjs(item?.createdOn).format('DD/MM/YYYY')}
                                                    <br />
                                                    <span style={{ whiteSpace: 'nowrap' }}>{new Date(item?.createdOn).toLocaleTimeString('en-US', {
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        second: '2-digit',
                                                        hour12: true, // enables AM/PM
                                                    })}</span>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>{item?.month}/{item?.year}</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>{item?.userId?.firstName} {item?.userId?.lastName}</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }} className='extra' ><IconButton onClick={() => handleCopyEmail(item?.userId?.emailId)}><Copy /></IconButton></TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>{item?.shopperInvoiceStatusId?.invoiceStatusName}</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>{item?.totalAmountToPay}</TableCell>
                                                {/* <TableCell sx={{ textAlign: 'center' }}>{item?.transactionId}</TableCell> */}
                                                {/* <TableCell sx={{ textAlign: 'center' }}>{item?.transactionDate}</TableCell> */}
                                                <TableCell sx={{ textAlign: 'center' }}><SettingsBackupRestore /></TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}><IconButton onClick={() => { handleSinglePay(item) }}><LocalAtm /></IconButton></TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}><IconButton onClick={() => { ShopperInvoicePDF(item?.shopperInvoiceId, item?.userId?.userId) }}><PictureAsPdf /></IconButton></TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Link
                                                     to ={`/admin/invoices/invoice-details/${item?.shopperInvoiceId }`}
                                                    >
                                                        <Box component='img' className='w-25' src={details}></Box>
                                                    </Link></TableCell>


                                            </TableRow>
                                        )))
                                    : <TableCell className='text-center' colSpan={18}><Typography>No Data Found</Typography></TableCell>
                            }

                        </TableBody>
                    </Table>
                </Box>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={datalength}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                {/* </TableContainer> */}
                <Dialog open={airtaskerDialogOpen} onClose={() => setAirtaskerDialogOpen(false)} maxWidth="sm" fullWidth>
                    <DialogTitle sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontSize: '16px', color: 'gray', fontWeight: 'bold' }}>
                                Airtasker Jobs
                            </Typography>
                            <IconButton onClick={() => setAirtaskerDialogOpen(false)} size="small">
                                <CancelOutlined fontSize="small" />
                            </IconButton>
                        </Stack>
                    </DialogTitle>

                    <Divider />

                    <DialogContent>
                        <Typography sx={{ mb: 2, color: 'gray', fontSize: '17px' }}>
                            Note: Below are airtasker jobs which won't be in invoice.
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                        <TableContainer sx={{ border: '1px solid #c8cbcf', borderRadius: 1 }}>
                            <Table sx={{ minWidth: 300 }} size="small">
                                <TableHead>
                                    <TableRow>
                                        {['MM', 'ALDI', 'BLOOMS'].map((col, index) => (
                                            <TableCell
                                                key={col}
                                                align="center"
                                                sx={{
                                                    fontWeight: 'bold',
                                                    background: '#c8cbcf',
                                                    borderRight: `${index !== 2 && '1px solid #fff'}`,
                                                    color: '#000',
                                                }}
                                            >
                                                {col}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        {airTaskerStatsData.map((val, idx) => (
                                            <><TableCell
                                                key={idx}
                                                align="center"
                                                sx={{ borderRight: idx < 2 ? '1px solid #ddd' : 'none' }}
                                            >
                                                {val?.mm_count}
                                            </TableCell><TableCell
                                                key={idx}
                                                align="center"
                                                sx={{ borderRight: idx < 2 ? '1px solid #ddd' : 'none' }}
                                            >
                                                    {val?.aldi_count}
                                                </TableCell>
                                                <TableCell
                                                    key={idx}
                                                    align="center"
                                                    sx={{ borderRight: idx < 2 ? '1px solid #ddd' : 'none' }}
                                                >
                                                    {val?.blooms_count}
                                                </TableCell></>
                                        ))}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>

                    <Divider sx={{ my: 2 }} />

                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button
                            variant="contained"
                            onClick={() => handleDownloadExcel()}
                            sx={{
                                backgroundColor: '#75724C',
                                textTransform: 'uppercase',
                                fontWeight: 600,
                                fontSize: '13px',
                                px: 3.5,
                                py: 0.8,
                            }}
                        >
                            Download as Excel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => setAirtaskerDialogOpen(false)}
                            sx={{
                                backgroundColor: 'rgb(92, 100, 106)',
                                textTransform: 'uppercase',
                                fontWeight: 600,
                                fontSize: '13px',
                                px: 3.5,
                                py: 0.8,
                            }}
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </div >
    )
}

export default PayInvoice
